import { Col, Form, notification, Row, Table } from 'antd'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './selfInspection.module.css'
import { RootDispatch } from '../../app/store'
import { PrintFrameRef } from '../print/PrintFrame'
import { selectTenantName } from '../../app/applicationSlice'
import { DateRangeType, getDateRange } from '../../compnents/form/DateSelect'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { Query } from './Query'
import { EditableList } from '../../compnents/list/EditableList'
import { Columns } from './column'
import { getSJWHTokenAsync } from '../dataMaintenance/organization/data'
import axios from 'axios'
import { AXIOS_IP } from '../filingManagement/fileUploadService'

export const SelfInspectionWithLaw = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const printRef = useRef<PrintFrameRef>(null)

  const tenantName = useSelector(selectTenantName)

  const [token, setToken] = useState("")

  const [page, setPage] = useState<any>()

  const [queries, setQueries] = useState<any>({
    pageSize: 10,
    pageNo: 1,
    timeHead: '',
    timeTail: '',
  })

  const [pageLoading, setPageLoading] = useState<any>()

   const getData = () => {
      setPageLoading(true)
      dispatch(getSJWHTokenAsync())
        .then(unwrapResult)
        .then((token: any) => {
          setToken(token)
          axios({
            url: `${AXIOS_IP}/selfInspection/list`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": token,
            },
            withCredentials: false,
            method: "POST",
            data: {
              ...queries,
              searchTimeList: [queries?.timeHead, queries?.timeTail],
              timeHead: undefined,
              timeTail: undefined,
            },
          }).then((res) => {
            setPage({
              ...page,
              items: res.data.data?.records || res.data.data?.list,
              total: res.data.data?.total,
            })
            setPageLoading(false)
          })
        })
    }

  useEffect(() => {
    getData()
  }, [queries])

  return (
    <>
      <TabBar
        defaultValue={0}
        style={{ margin: "10px 20px", position: "relative" }}
      >
        <TabPane key="0" tab="依法执业自查">
          <div className={styles.contents}>
            <Query
              loading={pageLoading}
              onValueChange={(v: any) => {
                setQueries({
                  ...queries,
                  ...v,
                });
              }}
            />
            <EditableList
              className={styles.sellingExpenseSummaryMain}
              loading={pageLoading}
              rowKey={(_, i) =>
                queries
                  ? (queries.pageSize || 0) * (queries.pageNo || 0) + (i || 0)
                  : 0
              }
              page={{
                items: page?.items,
                current: queries.pageNo || 1,
                size: queries?.pageSize || 10,
                total: page?.total,
              }}
              columns={Columns(
                queries?.pageSize * (queries?.pageNo - 1),
                page?.items
              )}
              onChangePage={(current: any, pageSize: any) => {
                setQueries({
                  ...queries,
                  pageNo: current,
                  pageSize: pageSize,
                });
              }}
            />
          </div>
          <div className={styles.remark}>
            <p>注：</p>
            <p>1.年度全面自查应于每年1月的第一个工作周内进行并提交；没有该项目的，填“无”。</p>
            <p>2.季度自查应于每年4月、7月、10月的第一个工作周内进行并提交；没有该项目的，填“无”。</p>
          </div>
        </TabPane>
      </TabBar>
    </>
  );
}
